import { t } from '../../../../utils/i18n';
import { getDisplayItems } from '../utils/getTransactionInfo';
import { WidgetProps } from '../../../../types/WidgetProps';
import { BiLogger } from '../../../Hoc/BiLogger/BiLoggerProvider';
import { GooglePayButtonConfig } from '../types';
import { getShippingContactError } from '../utils/getShippingContactError';
import { getShippingOptions } from '../utils/getShippingOptions';
import { ShippingError } from '../../../../types/Shipping';

type CreateOnShippingContactSelectedParams = {
  topProps: WidgetProps;
  transactionInfo: google.payments.api.TransactionInfo;
  biLogger: BiLogger;
};

type OnShippingContactSelectedParams = Parameters<GooglePayButtonConfig['onPaymentDataChanged']>[0]['shippingAddress'];

export const createOnShippingContactSelected =
  ({ topProps, transactionInfo }: CreateOnShippingContactSelectedParams) =>
  async (
    params: OnShippingContactSelectedParams,
  ): Promise<ReturnType<GooglePayButtonConfig['onPaymentDataChanged']>> => {
    const { locale, currency } = topProps;
    try {
      const updates = await topProps.onShippingContactSelected({
        countryCode: params.countryCode,
        state: params.administrativeArea,
        city: params.locality,
        postalCode: params.postalCode,
      });
      const { error, paymentAmount } = updates;
      const isError = error in ShippingError;
      const totalPrice = isError ? topProps.paymentAmount : paymentAmount;

      return {
        ...(isError && { error: getShippingContactError(error) }),
        newTransactionInfo: {
          ...transactionInfo,
          totalPrice,
          ...(updates.paymentBreakdown && { displayItems: getDisplayItems(updates.paymentBreakdown) }),
        },
        ...(updates.shippingMethods && {
          newShippingOptionParameters: {
            shippingOptions: getShippingOptions({
              shippingMethods: updates.shippingMethods,
              locale,
              currencyCode: currency,
            }),
          },
        }),
      };
    } catch (error) {
      return {
        newTransactionInfo: {
          ...transactionInfo,
          totalPrice: topProps.paymentAmount,
        },
        error: {
          reason: 'OTHER_ERROR',
          intent: 'SHIPPING_ADDRESS',
          message: t('pm.shipping.unknownError'),
        },
      };
    }
  };
